// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  background-color: #fff;
  display: flex;
  justify-content: center;
  margin: 0;
  height: 79vh;
}

.login-title {
  text-align: center;
  padding-right: 0;
  margin-bottom: 20px;
  font-size: 1.5rem;
  color: #333;
}

.login-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  background-color: #0a65cc;
  color: #fff;
  border-radius: 8px;
  width: 100%;
  padding: 15px;
  margin-bottom: 16px;
}

.signup-link {
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.input-login {
  background-color: #f5f5f5;
  padding: 5px 10px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.032) 0px 1px 4px;
}

.login-form-control {
  background-color: transparent;
  padding: 0;
  border: none;
  margin-top: 5px;
}

.login-form-control:focus,
.login-form-control:default {
  background-color: transparent;
}

.login-footer-bar {
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
  text-align: right;
  font-size: 14px;
  color: #000000;
  padding: 10px;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin: 0;
}

.login-navigation-bar {
  display: flex;
  justify-content: left;
  align-items: left;
  padding: 10px 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./../portfolio/src/pages/CandidateUserLogin/CandidateUserLogin.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EAEA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,4CAAA;AADF;;AAIA;EACE,6BAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;;EAEE,6BAAA;AADF;;AAIA;EACE,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,yCAAA;EACA,aAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gCAAA;EACA,wCAAA;EACA,gBAAA;EACA,MAAA;EACA,aAAA;EACA,kBAAA;AADF","sourcesContent":[".login-container {\n  background-color: #fff;\n  display: flex;\n  justify-content: center;\n  margin: 0;\n  height: 79vh;\n}\n\n.login-title {\n  text-align: center;\n  padding-right: 0;\n  margin-bottom: 20px;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.login-button {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n\n  background-color: #0a65cc;\n  color: #fff;\n  border-radius: 8px;\n  width: 100%;\n  padding: 15px;\n\n  margin-bottom: 16px;\n}\n\n.signup-link {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n}\n\n.input-login {\n  background-color: #f5f5f5;\n  padding: 5px 10px;\n  border-radius: 8px;\n  box-shadow: rgba(0, 0, 0, 0.032) 0px 1px 4px;\n}\n\n.login-form-control {\n  background-color: transparent;\n  padding: 0;\n  border: none;\n  margin-top: 5px;\n}\n\n.login-form-control:focus,\n.login-form-control:default {\n  background-color: transparent;\n}\n\n.login-footer-bar {\n  background-color: #ffffff;\n  border-top: 1px solid #e0e0e0;\n  text-align: right;\n  font-size: 14px;\n  color: #000000;\n  padding: 10px;\n  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  margin: 0;\n}\n\n.login-navigation-bar {\n  display: flex;\n  justify-content: left;\n  align-items: left;\n  padding: 10px 20px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #e0e0e0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
